import React from 'react';
import scrapedData from './anaokulu_content.json';

const menuItems = [
  { label: 'Anaokulu', id: 'anaokulu' },  
  { label: 'Kadromuz', id: 'kadro' },
  { label: 'Eğitim Öğretim Modeli', id: 'model' },
  { label: 'Montessori Programı', id: 'montessori' },
  { label: 'İngilizce Programı', id: 'ingilizce' },
  { label: 'Kültür-Sanat ve Spor Programlarımız', id: 'kultur' },
  { label: 'Rehberlik', id: 'rehberlik' },
];

const Anaokulu = () => {
  return (
    <div className="flex flex-col md:flex-row min-h-screen bg-white text-gray-800" style={{ backgroundImage: "url('/background.png')" }} >
      {/* Sol Menü */}
      <aside className="md:w-64 w-full bg-[#8b0000] text-white p-4 space-y-2 md:sticky top-0 mt-[72px] md:self-start z-10">
        <h2 className="text-xl font-bold mb-4">ANAOKULU</h2>
        {menuItems.map((item, idx) => (
          <a
            key={idx}
            href={`#${item.id}`}
            className="block px-4 py-3 border-b border-white hover:bg-white hover:text-[#8b0000] transition font-medium text-sm"
          >
            <span className="mr-2">❯</span> {item.label}
          </a>
        ))}
      </aside>

      {/* İçerik */}
      <main className="flex-1 p-6 md:p-12 space-y-16">
        {menuItems.map((item) => {
          const sectionData = scrapedData.find((data) => data.id === item.id);
          return (
            <section key={item.id} id={item.id} className="py-10">
              <h2 className="text-2xl font-bold text-[#a03838] mb-4">{item.label}</h2>
              {sectionData?.text && <p className="mb-4 whitespace-pre-line">{sectionData.text}</p>}
              {sectionData?.images?.length > 0 && (
                <div className="flex flex-wrap gap-4">
                  {sectionData.images.map((img, i) => (
                    <img
                      key={i}
                      src={img}
                      alt={`img-${item.id}-${i}`}
                      className="w-full md:w-1/2 lg:w-1/3 rounded-lg shadow"
                    />
                  ))}
                </div>
              )}
            </section>
          );
        })}
      </main>
    </div>
  );
};

export default Anaokulu;


// import React from 'react';

// const menuItems = [
//   { label: 'Anaokulu', id: 'anaokulu' },  
//   { label: 'Kadromuz', id: 'kadro' },
//   { label: 'Eğitim Öğretim Modeli', id: 'model' },
//   { label: 'Montessori Programı', id: 'montessori' },
//   { label: 'İngilizce Programı', id: 'ingilizce' },
//   { label: 'Kültür-Sanat ve Spor Programlarımız', id: 'kultur' },
//   { label: 'Rehberlik', id: 'rehberlik' },
// ];

// const Anaokulu = () => {
//   return (
//     <div className="flex flex-col md:flex-row min-h-screen bg-white text-gray-800" style={{ backgroundImage: "url('/background.png')" }} >
//       {/* Sol Menü */}
//       <aside className="md:w-64 w-full bg-[#8b0000] text-white p-4 space-y-2 sticky top-[64px] self-start z-10">
//         <h2 className="text-xl font-bold mb-4">ANAOKULU</h2>
//         {menuItems.map((item, idx) => (
//           <a
//             key={idx}
//             href={`#${item.id}`}
//             className="block px-4 py-3 border-b border-white hover:bg-white hover:text-[#8b0000] transition font-medium text-sm"
//           >
//             <span className="mr-2">❯</span> {item.label}
//           </a>
//         ))}
//       </aside>

//       {/* İçerik */}
//       <main className="flex-1 p-6 md:p-12 space-y-16">
//         <section id="anaokulu" className="py-10">
//           <h2 className="text-2xl font-bold text-[#a03838] mb-4">Anaokulu</h2>
//           <p>
//             Anaokulumuzda görev yapan tüm öğretmenlerimiz çocuk gelişimi, okul öncesi eğitim ve pedagojik formasyon konularında uzmanlaşmıştır...
//           </p>
//         </section>
//         <section id="kadro">
//           <h2 className="text-2xl font-bold text-[#a03838] mb-4">Kadromuz</h2>
//           <p>
//             Anaokulumuzda görev yapan tüm öğretmenlerimiz çocuk gelişimi, okul öncesi eğitim ve pedagojik formasyon konularında uzmanlaşmıştır...
//           </p>
//         </section>

//         <section id="model">
//           <h2 className="text-2xl font-bold text-[#a03838] mb-4">Eğitim Öğretim Modeli</h2>
//           <p>
//             Oyun temelli, öğrenci merkezli, keşfetmeye dayalı bir eğitim sistemi uygulanmaktadır...
//           </p>
//         </section>

//         <section id="montessori">
//           <h2 className="text-2xl font-bold text-[#a03838] mb-4">Montessori Programı</h2>
//           <p>
//             Montessori eğitimiyle çocuklarımız bağımsızlık, öz disiplin ve sorumluluk becerilerini geliştirir...
//           </p>
//         </section>

//         <section id="ingilizce">
//           <h2 className="text-2xl font-bold text-[#a03838] mb-4">İngilizce Programı</h2>
//           <p>
//             İngilizce, erken yaşta edinilen bir iletişim aracı olarak haftalık yoğun program dahilinde uygulanır...
//           </p>
//         </section>

//         <section id="kultur">
//           <h2 className="text-2xl font-bold text-[#a03838] mb-4">Kültür-Sanat ve Spor Programlarımız</h2>
//           <p>
//             Sanat atölyeleri, müzik çalışmaları ve spor etkinlikleri ile çocuklarımızın sosyal ve fiziksel gelişimi desteklenir...
//           </p>
//         </section>

//         <section id="rehberlik">
//           <h2 className="text-2xl font-bold text-[#a03838] mb-4">Rehberlik</h2>
//           <p>
//             Okul öncesi döneme uygun rehberlik çalışmaları ile öğrencilerimizin duygusal ve sosyal gelişimleri izlenmektedir...
//           </p>
//         </section>
//         <section id="etkinlikler">
//           <h2 className="text-2xl font-bold text-[#a03838] mb-4">Etkinlikler</h2>
//         </section>
//       </main>
//     </div>
//   );
// };

// export default Anaokulu;


